<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="800px"
    :content-class="((getForAccessibility) ? ' for-accessibility-app ' : '')"
    style="min-width: 600px;"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="modalloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1" v-if="!modalloading">
        <span>{{ showTitle }}</span>
        <v-spacer></v-spacer>
        <v-btn icon @click.native.stop="closeModal()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <!-- search  -->
        <v-card outlined>
          <v-card-text>
            <v-row>
              <!-- searchBy  -->
              <v-col v-if="showSearchBySelect && !isCourt" cols="12" md="12">
                <v-btn-toggle
                  @change="searchByChange()"
                  v-model="searchBy"
                  mandatory
                >
                  <v-btn v-if="showFiz" active-class="active-btn-group-item" small value="FIZ">
                    <v-icon style="padding-right: 4px">mdi-account</v-icon>
                    <span>{{ $t('Fizinis asmuo') }}</span>
                  </v-btn>
                  <v-btn v-if="showJur" active-class="active-btn-group-item" small value="JUR">
                    <v-icon style="padding-right: 4px">mdi-bank</v-icon>
                    <span>{{ $t('Juridinis asmuo') }}</span>
                  </v-btn>
                </v-btn-toggle>
              </v-col>
              <!-- court -->
                 <template v-if="isCourt">
                <v-col class="pb-0" cols="12" md="6">
                  <el-text-field
                    required
                    label="Kodas"
                    v-model="formData.code"
                    validateKey="JUR_code"
                    key="JUR_code"
                    :cMask="9"
                  />
                </v-col>
                <v-col class="pb-0" cols="12" md="6"></v-col>

                <!-- LOCAL DATA -->
                <template v-if="isLocal">
                  <v-btn v-for="(person, index) in localData.juridical" :key="'juridicalLocal' + index" v-on:click="addPerson(person, 'jur')" class="mr-1 mb-1">{{ person.fullname }}</v-btn>
                </template>

              </template>
              <!-- individual  -->
              <template v-if="showIndividual">
                <v-col class="pb-0" cols="12" md="6">
                  <el-text-field
                    required
                    label="Asmens kodas"
                    v-model="formData.code"
                    personalCode
                    validateKey="FIZ_code"
                    key="FIZ_code"
                  />
                </v-col>
                <v-col class="pb-0" cols="12" md="6"></v-col>
                <v-col class="pb-0" cols="12" md="6">
                  <el-text-field
                    required
                    label="Vardas"
                    v-model="formData.name"
                    validateKey="FIZ_name"
                    key="FIZ_name"
                  />
                </v-col>
                <v-col class="pb-0" cols="12" md="6">
                  <el-text-field
                    required
                    label="Pavardė"
                    v-model="formData.lastname"
                    validateKey="FIZ_lastname"
                    key="FIZ_lastname"
                  />
                </v-col>

                <!-- LOCAL DATA -->
                <template v-if="isLocal">
                  <v-col>
                    <v-btn v-on:click="addPerson(person, 'ind')" v-for="(person, index) in localData.individual" :key="'individualLocal' + index" class="mr-1 mb-1">{{ person.fullname }}</v-btn>
                  </v-col>
                </template>

              </template>
              <!-- legal person  -->
              <template v-if="showLegalPerson">
                <v-col class="pb-0" cols="12" md="6">
                  <el-text-field
                    required
                    label="Juridinio asmens kodas"
                    v-model="formData.code"
                    validateKey="JUR_code"
                    key="JUR_code"
                    :cMask="9"
                  />
                </v-col>
                <v-col class="pb-0" cols="12" md="6"></v-col>

                <!-- LOCAL DATA -->
                <template v-if="isLocal">
                  <v-btn v-for="(person, index) in localData.juridical" :key="'juridicalLocal' + index" v-on:click="addPerson(person, 'jur')" class="mr-1 mb-1">{{ person.fullname }}</v-btn>
                </template>

              </template>
              <!-- Individual foreigner  -->
              <template v-if="showIndividualForeigner">
                <v-col class="pb-0" cols="12" md="6">
                  <el-text-field
                    required
                    label="Vardas"
                    v-model="formData.name"
                    validateKey="UZS_name"
                    key="UZS_name"
                  />
                </v-col>
                <v-col class="pb-0" cols="12" md="6">
                  <el-text-field
                    required
                    label="Pavardė"
                    v-model="formData.lastname"
                    validateKey="UZS_lastname"
                    key="UZS_lastname"
                  />
                </v-col>
                <template v-if="hideForeignerRadio">
                  <v-col class="pb-0" cols="12" md="12">
                    <el-text-field
                      required
                      label="ILTU kodas"
                      v-model="formData.code"
                      validateKey="iltu_code"
                    />
                  </v-col>
                </template>
                <template v-else>
                  <v-col class="pt-0 pb-0" cols="12" md="12">
                    <el-radio-group
                      @change="changeparameterType()"
                      class="mt-0 mb-4"
                      label="parameterType"
                      v-model="formData.parameterType"
                      :items="parameterType"
                      required
                    >
                    </el-radio-group>
                  </v-col>
                  <template v-if="showForeignerCode">
                    <v-col class="pb-0" cols="12" md="12">
                      <el-text-field
                        required
                        label="ILTU kodas"
                        v-model="formData.code"
                        validateKey="iltu_code"
                        maxlength="20"
                      />
                    </v-col>
                    <v-col class="pb-0" cols="12" md="6"></v-col>
                  </template>
                  <template v-if="showForeignerDateAndCountry">
                    <v-col class="pb-0" cols="12" md="6">
                      <el-date-picker
                        required
                        pastDates
                        label="Gimimo data"
                        v-model="formData.birth_date"
                        validateKey="birth_date"
                        key="birth_date"
                      />
                    </v-col>
                    <v-col class="pb-0" cols="12" md="6">
                      <el-autocomplete style="z-index: 1000"
                        :required="!checkBeforeAddRaw"
                        v-if="showForeignerPp"
                        :items="classifiers.country"
                        itemvalue="value"
                        itemtext="text"
                        label="Valstybė"
                        v-model="formData.country"
                        validateKey="uzs_country_pp"
                        key="uzs_country_pp"
                      />
                      <el-autocomplete
                        v-else
                        required
                        :items="classifiers.country"
                        itemvalue="value"
                        itemtext="text"
                        label="Šalis"
                        v-model="formData.country"
                        validateKey="uzs_country"
                        key="uzs_country"
                      />
                    </v-col>
                    <v-col class="pb-0" cols="12" md="12" v-if="showForeignerPp">
                      <el-text-field
                        label="Fizinio asmens identifikavimo kodas užsienio valstybėje"
                        v-model="formData.foreigner_code"
                        validateKey="iltu_code"
                        maxlength="20"
                      />
                    </v-col>
                    <v-col class="pb-0" cols="12" md="12" v-if="showForeignerPp">
                      <el-autocomplete style="z-index: 1000"
                        :required="isPersonDocumentsMandatory"
                        :items="classifiers['person-document-kind']"
                        itemvalue="value"
                        itemtext="text"
                        label="Asmens dokumento rūšis"
                        v-model="formData.person_document_kind_id"
                        validateKey="person_document_kind_id"
                        key="person_document_kind_id"
                      />
                    </v-col>
                    <v-col class="pb-0" cols="12" md="6" v-if="showForeignerPp">
                      <el-date-picker
                        :required="isPersonDocumentsMandatory"
                        pastDates
                        label="Asmens dokumento išdavimo data"
                        v-model="formData.person_document_date"
                        validateKey="person_document_date"
                        key="person_document_date"
                      />
                    </v-col>
                    <v-col class="pb-0" cols="12" md="6" v-if="showForeignerPp">
                      <el-text-field
                        :required="isPersonDocumentsMandatory"
                        label="Asmens dokumento numeris"
                        v-model="formData.person_document_number"
                        validateKey="person_document_number"
                        maxlength="20"
                      />
                    </v-col>
                    <v-col class="pb-0" cols="12" md="12" v-if="showForeignerPp">
                      <h4 class="mb-2">{{ $t('Asmens dokumentai') }}<span v-if="isPersonDocumentsMandatory" class="error--text">*</span></h4>
                      <el-file-upload-table
                        v-model="formData.person_document_files"
                        :multiple="true"
                        :readonly="false"
                        uploadButtonText="Įkelti dokumentą"
                        emptyStateText="Nėra įkeltų dokumentų"
                      />
                    </v-col>
                  </template>
                </template>

                <!-- LOCAL DATA -->
                <template v-if="isLocal">
                  <v-btn v-for="(person, index) in localData.foreigner" :key="'foreignerLocal' + index" v-on:click="addPerson(person, 'for')"  class="mr-1 mb-1">{{ person.fullname }}</v-btn>
                </template>

              </template>
               <!-- Legal person foreigner  -->
              <template v-else-if="showLegalPersonForeigner">
                <v-col class="pb-0" cols="12" md="6">
                  <el-text-field
                    required
                    label="Juridinio asmens kodas"
                    v-model="formData.foreigner_code"
                    validateKey="JUR_foreigner_code"
                    key="JUR_foreigner_code"
                    maxlength="20"
                  />
                </v-col>
                <v-col class="pb-0" cols="12" md="6">
                  <el-text-field
                    required
                    label="Pavadinimas"
                    v-model="formData.name"
                    validateKey="JUR_foreigner_name"
                    key="JUR_foreigner_name"
                    :maxlength="200"
                  />
                </v-col>
                <v-col class="pb-0" cols="12" md="6">
                  <el-autocomplete style="z-index: 1000"
                    required
                    :items="classifiers.country"
                    itemvalue="value"
                    itemtext="text"
                    label="Užsienio valstybė"
                    v-model="formData.country"
                    validateKey="jur_foreigner_country"
                    key="jur_foreigner_country"
                  />
                </v-col>
              </template>
              <template v-if="showLegalForeignerSwitch">
                <v-col class="pb-4 pt-0" cols="12" md="12">
                  <el-switch @change="changeForeinerSwitch" :label="getUZSLabel" v-model="formData.foreigner">
                  </el-switch>
                </v-col>
              </template>

              <v-col class="pb-2 pt-0" cols="12" md="12">
                <el-button
                  :title="getMainButtonTitle"
                  small
                  @mouseover="setCountryRequired(false)"
                  icon="ieškoti"
                  class="mr-2"
                  :loading="loading"
                  @click.native.stop="beforeSearch()"
                  color="primary"
                />
                <el-button
                  title="Išvalyti"
                  icon="išvalyti"
                  small
                  :loading="loading"
                  @click.native="clear()"
                  color="secondary"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- persons table data -->
        <v-card v-if="showPersonsTable" class="mt-4" outlined>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="12">
                <v-simple-table dense>
                  <thead>
                    <tr>
                      <th>AMN ID (Tipas)</th>
                      <th>Vardas Pavardė</th>
                      <th style="min-width: 100px;">Gimimo data</th>
                      <th>Fizinio asmens identifikavimo kodas užsienio valstybėje</th>
                      <th>Valstybė</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="person in personsTableData" :key="person.amn_id">
                      <td>{{ person.amn_id }} {{ person.amnt_type }}</td>
                      <td>{{ person.fullname }}</td>
                      <td>{{ person.birth_date }}</td>
                      <td>{{ person.foreigner_code }}</td>
                      <td>{{ person.country_name }}</td>
                      <td>
                        <el-button
                          small
                          title="Pridėti"
                          icon="pridėtiAsmenį"
                          :loading="loading"
                          @click.native="addDataFromTable(person)"
                          color="primary"
                        />
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-col cols="12" v-if="stillAdd">Asmenyse asmuo nerastas. Ar norite įrašyti asmenį į ASMENYS?<br>Jei taip, spauskite mygtuką [Įrašyti asmenį į ASMENYS]</v-col>
        <v-card-actions
          class="modalActions justify-end"
          elevation="5"
          v-if="checkBeforeAddRaw && showForeignerDateAndCountry"
        >
          <el-button
            @mouseover="setCountryRequired(true)"
            title="Įrašyti asmenį į asmenys"
            :loading="loading"
            @click.native="addPersonToAsmenys()"
            color="primary"
          />
        </v-card-actions>
        <!-- person data  -->
        <v-card v-if="showpersonData" class="mt-4" outlined>
          <v-card-text>
            <v-row>
              <!-- FIZ  -->
              <template v-if="showPersonDataFIZ">
                <v-col cols="12" md="12">
                  <v-simple-table dense>
                    <template v-slot:default>
                      <tbody>
                        <tr class="n-hov">
                          <td>
                            <strong>{{ $t('Asmens kodas') }}: </strong>
                          </td>
                          <td>{{ personData.code || '-' }}</td>
                        </tr>
                        <tr class="n-hov">
                          <td>
                            <strong>{{ $t('Vardas') }}: </strong>
                          </td>
                          <td>{{ personData.name || '-' }}</td>
                        </tr>
                        <tr class="n-hov">
                          <td>
                            <strong>{{ $t('Pavardė') }}: </strong>
                          </td>
                          <td>{{ personData.lastname || '-' }}</td>
                        </tr>
                        <tr v-if="personData.facts" class="n-hov">
                          <td>
                            <strong>{{ $t('Vaidmenys') }}: </strong>
                          </td>
                          <td>{{ personData.facts }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </template>
              <!-- JUR  -->
              <template v-if="showPersonDataJUR">
                <v-col cols="12" md="12">
                  <v-simple-table dense>
                    <template v-slot:default>
                      <tbody>
                        <tr class="n-hov">
                          <td>
                            <strong
                              >{{ isCourt ?  $t('Kodas') : $t('Juridinio asmens kodas') }}:
                            </strong>
                          </td>
                          <td>{{ personData.code || '-' }}</td>
                        </tr>
                        <tr class="n-hov">
                          <td>
                            <strong
                              >{{ isCourt ?  $t('Pavadinimas') : $t('Juridinio asmens pavadinimas') }}:
                            </strong>
                          </td>
                          <td>{{ personData.fullname || '-' }}</td>
                        </tr>
                        <tr class="n-hov">
                          <td>
                            <strong>{{ $t('Buveinė') }}: </strong>
                          </td>
                          <td>{{ personData.adr_text || '-' }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </template>
              <!-- UZS -->
              <template v-if="showPersonDataUZS">
                <v-col cols="12" md="12">
                  <v-simple-table dense>
                    <template v-slot:default>
                      <tbody>
                        <tr class="n-hov">
                          <td>
                            <strong>{{ $t('Vardas') }}: </strong>
                          </td>
                          <td>{{ personData.name || '-' }}</td>
                        </tr>
                        <tr class="n-hov">
                          <td>
                            <strong>{{ $t('Pavardė') }}: </strong>
                          </td>
                          <td>{{ personData.lastname || '-' }}</td>
                        </tr>
                        <tr class="n-hov">
                          <td>
                            <strong>{{ $t('ILTU kodas') }}: </strong>
                          </td>
                          <td>{{ personData.iltu_code || '-' }}</td>
                        </tr>
                        <tr
                          v-if="showPersonForeignerDateAndCountry"
                          class="n-hov"
                        >
                          <td>
                            <strong>{{ $t('Gimimo data ir šalis') }}: </strong>
                          </td>
                          <td>{{ personData.other_info || '-' }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </template>
              <template v-if="showDates">
                 <v-col class="pb-0" cols="12" md="6">
                  <el-date-picker
                    label="Galioja nuo"
                    required
                    v-model="personData.valid_from"
                  />
                </v-col>
                <v-col class="pb-0"  cols="12" md="6">
                  <el-date-picker
                    label="Galioja iki"
                    :afterDate="personData.valid_from"
                    v-model="personData.valid_to"
                  />
                </v-col>
              </template>
            </v-row>

          </v-card-text>
          <v-card-actions class="modalActions" elevation="5">
            <v-spacer></v-spacer>
            <el-button
              title="Pridėti"
              icon="pridėtiAsmenį"
              :loading="loading"
              @click.native="addData()"
              color="primary"
            />
          </v-card-actions>
          <modal-custom
            :title="$t('Asmens patvirtinimas')"
            :text="confirmQuestion"
            trueText="Taip"
            falseText="Ne"
            :loading="loading"
            v-model="showConfirmModal"
            @confirmData="confirmApprove"
      />
        </v-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import ModalCustom from '@/components/modals/ModalCustom'
import ElFileUploadTable from '@/components/elements/ElFileUploadTable.vue'

export default {
  name: 'ModalAddPerson',
  components: {
    ModalCustom,
    ElFileUploadTable
  },
  props: {
    additionalData: [Object, Array],
    value: Boolean,
    modalType: String,
    mandate: Boolean,
    hideForeignerSelect: Boolean,
    hideIndividual: Boolean,
    hideLegalPerson: Boolean,
    checkBeforeAddRaw: Boolean,
    addRaw: Boolean,
    showForeignerPp: Boolean,
    parentSignature: [Object],
    dataType: [String],
    showCode: [Boolean],
    parentAmnId: [String],
    allowForeignJur: [Boolean, String]
  },
  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {
      isPersonDocumentsMandatory: false,
      localData: {
        individual: {},
        juridical: {},
        foreigner: {},
      },
      formData: {
        foreigner: false,
        person_document_files: null,
      },
      classifiers: {},
      personData: {},
      personsTableData: [],
      personUzsData: {},
      searchBy: null,
      loading: false,
      stillAdd: false,
      countryRequired: false,
      showConfirmModal: false,
      confirmQuestion: '',
    }
  },
  computed: {
    ...mapGetters(['getForAccessibility']),
    getMainButtonTitle() {
      if (this.checkBeforeAddRaw && this.showForeignerDateAndCountry) {
        return 'Tikrinti asmenį asmenyse'
      } else if (this.addRaw && this.showForeignerDateAndCountry) {
        return 'Pridėti'
      } else if (this.showLegalPersonForeigner) {
        return 'Pridėti'
      }
      return 'Ieškoti'
    },
    hideForeignerRadio(){
      if(this.showForeignerPp){
        return false
      } else {
        return this.mandate
      }

    },
    isCourt(){
      return this.modalType == 'court'
    },
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    showDates() {
      return  this.modalType == "blacklist"
    },
    showJur() {
      return  this.modalType != "jur_representers" && this.modalType != "procurators" && !this.hideLegalPerson
    },
    showFiz() {
      return  this.modalType != "persons" && this.modalType != "pro_principals" && !this.hideIndividual
    },
    showSearchBySelect() {
      return true
    },
    showPersonDataFIZ() {
      return this.personUzsData.type === 'FIZ' && !this.personUzsData.foreigner
    },
    showPersonDataJUR() {
      return this.personUzsData.type === 'JUR'
    },
    showPersonDataUZS() {
      return this.personUzsData.type === 'FIZ' && this.personUzsData.foreigner
    },
    showForeignerCode() {
      return this.formData.parameterType === 'code'
    },
    showForeignerDateAndCountry() {
      return this.formData.parameterType === 'date_and_country'
    },
    showPersonForeignerDateAndCountry() {
      return this.personUzsData.parameterType === 'date_and_country'
    },
    showIndividual() {
      return this.searchBy === 'FIZ' && !this.formData.foreigner
    },
    showLegalPerson() {
      return this.searchBy === 'JUR' && !this.formData.foreigner
    },
    showIndividualForeigner() {
      return this.formData.foreigner && this.searchBy === 'FIZ'
    },
    showLegalPersonForeigner() {
      return this.formData.foreigner && !!this.allowForeignJur && this.searchBy == 'JUR'
    },
    showLegalForeignerSwitch() {
      return this.searchBy === 'FIZ' || !!this.allowForeignJur
    },
    showTitle() {
      let title = 'Pridėti asmenį'
      this.modalType === 'institution' && (title = 'Pridėti instituciją')
      this.modalType == 'court' && (title = 'Teismas')
      return this.$t(title)
    },
    showpersonData() {
      return this.personData && Object.keys(this.personData).length > 0
    },
    showPersonsTable() {
      return this.personsTableData && this.personsTableData.length > 0
    },
    getUZSLabel() {
      return this.searchBy === 'FIZ'
        ? this.$t('Asmuo neregistruotas LR gyventojų registre')
        : this.$t('Asmuo neregistruotas LR Juridinių asmenų registre')
    },
    parameterType() {
      if (this.hideForeignerSelect){
        return [{
          label: this.$t('ILTU Kodas'),
          value: 'code',
        }]
      }
      if (this.showForeignerPp){
        return [{
          label: this.$t('ILTU Kodas'),
          value: 'code',
        },
        {
          label: this.$t('Gimimo data'),
          value: 'date_and_country',
        },
      ]
      }
      return [
        {
          label: this.$t('ILTU Kodas'),
          value: 'code',
        },
        {
          label: this.$t('Gimimo data ir šalis'),
          value: 'date_and_country',
        },
      ]
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },

  created() {
    this.isPersonDocumentsMandatory = sessionStorage.getItem('is_person_documents_mandatory') == 'true'
    console.log(sessionStorage.getItem('is_person_documents_mandatory'))
    this.getClassifiers()
    this.modalloading = false
  },
  methods: {
    confirmApprove() {
      this.$emit('addPersonData', this.personData);
      this.showConfirmModal = false
      this.confirmQuestion = ''
    },
    setCountryRequired(value){
      this.countryRequired = value
    },
    addPerson(person, type) {
      if (type == 'ind') {
        this.$set(this.formData, 'code', person.code ?? '')
        this.$set(this.formData, 'name', person.name ?? '')
        this.$set(this.formData, 'lastname', person.lastname ?? '')
      } else if (type == 'jur') {
        this.$set(this.formData, 'code', person.code ?? '')
      } else if (type == 'for') {
        this.$set(this.formData, 'name', person.name ?? '')
        this.$set(this.formData, 'lastname', person.lastname ?? '')
        this.$set(this.formData, 'birth_date', person.birth_date ?? '')
      }
    },
    addPersonToAsmenys() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          let formData = new FormData()
          formData.append('name', this.formData.name || '')
          formData.append('lastname', this.formData.lastname || '')
          formData.append('birth_date', this.formData.birth_date || '')
          formData.append('country', this.formData.country || '')
          formData.append('foreigner_code', this.formData.foreigner_code || '')
          this.$axios.post('persons/addToAsmenys', formData)
            .then((res) => {
              res.data.person.person_document_kind_id = this.formData.person_document_kind_id ?? ''
              res.data.person.person_document_kind_title_lt = this.classifiers['person-document-kind']['lt'].find(item => item.value === this.formData.person_document_kind_id)?.text || ''
              res.data.person.person_document_date = this.formData.person_document_date ?? ''
              res.data.person.person_document_number = this.formData.person_document_number ?? ''
              res.data.person.person_document_files = this.formData.person_document_files ?? ''
              this.$emit('addPersonData', res.data.person)
            })
            .catch((err) => {
              console.log(err)
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => this.loading = false)
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
    changeForeinerSwitch(){
      this.personData = {}
      this.personsTableData = []
      if(this.formData.foreigner){
        this.$set(this.formData, 'parameterType', 'country')
      } else {
        this.$set(this.formData, 'parameterType', 'code')
      }
    },
    submit(){
      if(this.showpersonData){
        this.addData()
      } else {
        this.search()
      }
    },
    changeparameterType() {
      if (this.showForeignerCode) {
        this.$set(this.formData, 'country', '')
        this.$set(this.formData, 'foreigner_code', '')
        this.$set(this.formData, 'birth_date', '')
        this.$set(this.formData, 'person_document_kind_id', '')
        this.$set(this.formData, 'person_document_date', '')
        this.$set(this.formData, 'person_document_number', '')
        this.$set(this.formData, 'person_document_files', null)
      } else {
        this.$set(this.formData, 'code', '')
      }
    },
    searchByChange() {
      this.clear()
    },
    clear() {
      // clear search
      this.formData = { foreigner: false, person_document_files: null }
      this.stillAdd = false
      // clear person
      this.personData = {}
      this.$nextTick(() => {
        this.errors.clear()
        this.$nextTick(() => {
          this.$validator.reset()
        })
      })
    },
    closeModal() {
      this.showModal = false
    },
    cancel() {
      this.closeModal()
    },
    getClassifiers() {
      this.loadDefault = true
      let requiredClassifiers = { classifiers: ['country', 'person-document-kind'] }
      this.$axios
        .post(`classifiers`, requiredClassifiers)
        .then((res) => {
          this.classifiers = res.data.classifiers
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loadDefault = false
        })

      if (this.isLocal) {
        this.$axios.get('local/person-data').then(res => {
          this.localData.individual = res.data.individual ?? {};
          this.localData.juridical = res.data.juridical ?? {};
          this.localData.foreigner = res.data.foreigner ?? {};
        });
      }
    },
    addDataFromTable(person) {
      // check
       if (this.modalType === 'representitives') {
        if (this.principalExist(person)) {
          return this.$root.$emit('DATA_ERROR_CODE', '000025')
        }
        if (this.representitiveExist(person)) {
          return this.$root.$emit('DATA_ERROR_CODE', '000026')
        }
      }
      if (this.modalType === 'principals') {
        if (this.representitiveExist(person)) {
          return this.$root.$emit('DATA_ERROR_CODE', '000026')
        }
        if (this.principalExist(person)) {
          return this.$root.$emit('DATA_ERROR_CODE', '000026')
        }
      }
      // add
      let info = person.birth_date + ' ' + person.country_name
      person.foreigner_code && (info += ` ${person.foreigner_code}`)
      person.other_info = info
      person.person_document_kind_id = this.formData.person_document_kind_id
      person.person_document_kind_title_lt = this.classifiers['person-document-kind']['lt'].find(item => item.value === this.formData.person_document_kind_id)?.text || ''
      person.person_document_date = this.formData.person_document_date
      person.person_document_number = this.formData.person_document_number
      person.person_document_files = this.formData.person_document_files
      this.$emit('addPersonData', person)
    },
    addRawData(legalPersonForeigner) {
      this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.isPersonDocumentsMandatory && this.showForeignerPp) {
            const files = this.formData.person_document_files
            const hasAtLeastOne = files && (Array.isArray(files) ? files.length > 0 : true)
            if (!hasAtLeastOne) {
              this.$root.$emit('DATA_ERROR_TEXT', 'Privaloma įkelti bent vieną asmens dokumentą')
              return
            }
          }
          let person = {}
          person.modalType = this.modalType
          person.amn_id = 'new_id'
          person.name = this.formData.name
          person.lastname = this.formData.lastname
          person.birth_date = this.formData.birth_date
          person.foreigner_code = this.formData.foreigner_code
          person.code = this.formData.code
          person.country = this.formData.country
          person.person_document_kind_id = this.formData.person_document_kind_id
          person.person_document_kind_title_lt = this.classifiers['person-document-kind']['lt'].find(item => item.value === this.formData.person_document_kind_id)?.text || ''
          person.person_document_date = this.formData.person_document_date
          person.person_document_number = this.formData.person_document_number
          person.person_document_files = this.formData.person_document_files
          let country = '';
          if (person.country) {
            country = this.classifiers.country.lt.filter((item) => {
              return item.value == person.country
            })[0].text || ''
          }
          if(legalPersonForeigner){
            person.fullname = this.formData.name
            person.name = null
            person.other_info = (person.foreigner_code ? (person.foreigner_code + ', ') : '') + country
            person.foreign_jur = true
            person.type = 'JUR'
            person.canEditContacts = true
            person.addJurRepresenter = true
          } else {
            person.type = 'FIZ'
            person.fullname = this.formData.name + ' ' + this.formData.lastname
            person.other_info = person.birth_date
              + (country ? ', ' + country : '')
              + (this.formData.foreigner_code ? (', ' + this.formData.foreigner_code) : '')
          }
          this.$emit('addPersonData', person)
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
    addData() {
      if (this.additionalData && this.modalType === 'representitives') {
        if (this.principalExist()) {
          return this.$root.$emit('DATA_ERROR_CODE', '000025')
        }
        if (this.representitiveExist()) {
          return this.$root.$emit('DATA_ERROR_CODE', '000026')
        }
      }
      if (this.additionalData && this.modalType === 'principals') {
        if (this.representitiveExist()) {
          return this.$root.$emit('DATA_ERROR_CODE', '000026')
        }
        if (this.principalExist()) {
          return this.$root.$emit('DATA_ERROR_CODE', '000026')
        }
      }
      if (this.additionalData && this.modalType === 'sub_representitives') {
        if (this.subRepresentitiveExist()) {
          return this.$root.$emit('DATA_ERROR_CODE', '000026')
        }
        if (this.principalExist()) {
          return this.$root.$emit('DATA_ERROR_CODE', '000025')
        }
      }
      if (this.additionalData && this.modalType === 'procurators') {
        if (this.procuratorsExist()) {
          return this.$root.$emit('DATA_ERROR_CODE', '000026')
        }
      }
      if (this.modalType === 'institution' && this.institutionExist()) {
        return this.$root.$emit(
          'DATA_ERROR_CODE',
          '000100'
        )
      }
      this.personData.modalType = this.modalType
      let otherInfo = ''
      if (this.showIndividual) {
        otherInfo = this.personData.adr_text || ''
      } else if (this.showLegalPerson) {
        otherInfo = this.personData.adr_text || ''
      } else {
        otherInfo = this.personData.other_info || ''
      }
      this.personData.other_info = otherInfo
      // if(this.modalType == 'blacklist'){
      //    this.$validator.validateAll().then((res) => {
      //     if (res) {
      //       this.$emit('addPersonData', this.personData)
      //     } else {
      //       this.$root.$emit('FORMAT_ERROR')
      //     }
      //    })
      // } else {
      //    this.checkPerson()
      // }
      if (this.modalType == 'jur_representers') {
        if (this.dataType == 'jur_representer_against_parent') {
          this.checkPersonAgaintParent()
        } else {
          if (!this.showCode) {
            this.personData.code = null
          }
          this.checkPersonAgaintParent()
          // this.$emit('addPersonData', this.personData)
        }
      } else {
        this.checkPerson()
      }
    },
    checkPersonAgaintParent() {
      this.loading = true
      let code = this.personData.code
      let amnId = this.personData.amn_id
      let dataType = this.dataType || this.modalType
      const isSavitarna = window.location.host === process.env.VUE_APP_SAVITARNA_HOST

      this.$axios
        .post('persons/checkPersonAgainst', {parentAmnId: (this.parentSignature && this.parentSignature.amn_id) || this.parentAmnId, code: code, dataType: dataType, amnId: amnId, isSavitarna: isSavitarna})
        .then((response) =>  {
          if(response.data?.askForQuestion) {
                this.showConfirmModal = true
                this.confirmQuestion = response.data?.question + 'Ar tikrai norite pridėti?'
              } else {
                  this.$emit('addPersonData', this.personData)
              }
        })
        .catch(err => this.$root.$emit('DATA_ERROR', err))
        .finally(() => {
          this.loading = false
        })
    },
    checkPerson() {
      this.loading = true
      let code = this.personData.code
      let type = this.personData.type
      let dataType = this.dataType || this.modalType
      const isSavitarna = window.location.host === process.env.VUE_APP_SAVITARNA_HOST

      this.$axios
        .post('persons/checkPerson', { code: code, type: type, dataType: dataType, isSavitarna: isSavitarna })
        .then((response) => {
          // this.$emit('addPersonData', this.personData)
          if (this.modalType == 'blacklist'){
            this.$validator.validateAll().then((res) => {
              if (res) {
                this.$emit('addPersonData', this.personData)
              } else {
                this.$root.$emit('FORMAT_ERROR')
              }
            })
          } else {
              if(response.data?.askForQuestion) {
                this.showConfirmModal = true
                this.confirmQuestion = response.data?.question + 'Ar tikrai norite pridėti?'

              } else {
                  this.$emit('addPersonData', this.personData)
              }
          }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    procuratorsExist() {
      return (
        this.additionalData.procurators &&
        this.additionalData.procurators.filter(
          (item) => item.amn_id && item.id != 'new_id' && item.amn_id === this.personData.amn_id
        ).length
      )
    },
    principalExist(person) {
      if(person){
        return (
        this.additionalData.principals &&
        this.additionalData.principals.filter(
          (item) => item.amn_id === person.amn_id
        ).length
      )
      }
      return (
        this.additionalData.principals &&
        this.additionalData.principals.filter(
          (item) => item.amn_id === this.personData.amn_id
        ).length
      )
    },
    subRepresentitiveExist(person) {
      if(person){
        return (
        this.additionalData.principals &&
        this.additionalData.principals.filter(
          (item) => item.amn_id === person.amn_id
        ).length
      )
      }
      return (
        this.additionalData.sub_representitives &&
        this.additionalData.sub_representitives.filter(
          (item) => item.amn_id === this.personData.amn_id
        ).length
      )
    },
    representitiveExist() {
      return (
        this.additionalData.representitives &&
        this.additionalData.representitives.filter(
          (item) => item.amn_id === this.personData.amn_id
        ).length
      )
    },
    institutionExist() {
      return this.additionalData.filter(
        (item) => item.amn_id === this.personData.amn_id
      ).length
    },

    // Helper method for conditional validation
    getValidationPromise() {
      // Determine which fields to validate based on conditions
      let fieldsToValidate = []

      if (this.checkBeforeAddRaw && this.showForeignerDateAndCountry) {
        // Only validate specific fields for foreigner date and country check
        fieldsToValidate = ['birth_date', 'UZS_name', 'UZS_lastname']
      }

      // Return validation promise (all by default, or specific fields if condition is met)
      if (fieldsToValidate.length > 0) {
        // Validate specific fields using array syntax
        return Promise.all(fieldsToValidate.map(field => this.$validator.validate(field)))
          .then(results => results.every(result => result))
      } else {
        return this.$validator.validateAll()
      }
    },

    beforeSearch(){
      if(this.addRaw && this.showForeignerDateAndCountry){
        this.addRawData()
      } else if(this.showLegalPersonForeigner){
        this.addRawData(true)
      } else {
         this.search()
      }
    },
    search() {
      this.getValidationPromise().then((res) => {
      // this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          let formData = this.formData
          if(this.isCourt){
            formData.type = 'JUR'
          } else {
            formData.type = this.searchBy
          }
          formData.dataType = this.dataType || this.modalType
          this.hideForeignerRadio && (formData.parameterType = 'code')
          let url
          let multipleResults = false
          if (this.checkBeforeAddRaw && this.showForeignerDateAndCountry) {
            multipleResults = true
            url = `persons/getForeigners`
          } else if (this.addRaw && this.showForeignerDateAndCountry) {
            this.$emit('addPersonData', this.personData)
            return
          } else {
            url = `persons/getByAsmCode`
            if (this.parentSignature != undefined) {
              formData.parentAmnId = this.parentSignature.amn_id
            }
          }
          this.$axios
            .post(url, formData)
            .then((res) => {
              this.stillAdd = false;
              if (multipleResults) {
                this.personsTableData = res.data.persons
              } else {
                this.personData = res.data.person
                if(this.showForeignerDateAndCountry){
                  this.personData.iltu_code = '-'
                }
                if (res.data.person.is_public) {
                  this.$emit('publicPersonWarning', null)
                }
                this.personUzsData = JSON.parse(JSON.stringify(this.formData))
              }
              this.personData.type = this.searchBy
              this.$root.$emit('DATA_OK_CODE', '000112')
            })
            .catch((err) => {
              if (multipleResults) {
                this.personsTableData = []
                this.stillAdd = true;
              } else {
                this.$root.$emit('DATA_ERROR', err)
              }
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
    translateRoles(roles) {
      let transated = ''
      if (roles.length > 0) {
        for (let i = 0; i < roles.length; i++) {
          transated += this.$t(roles[i])
          if (roles.length - 1 != i) {
            transated += ', '
          }
        }
      }
      return transated;
    },
  },
  // watch: {
  //   confirmQuestion(newVal) {
  //     if (newVal != '') {
  //       this.showConfirmModal = true;
  //     }
  //   }
  // }
}
</script>
<style lang="scss" scoped></style>
